module.exports = __webpack_public_path__ + "static/media/jasper_ai.c56a212b.png";